<template>
  <div class="acr-main">
    <!-- 表格 -->
    <el-table :data="showTableData" border style="width: 100%;" max-height="775px">
      <el-table-column prop="id" label="ID" width="330"></el-table-column>
      <el-table-column prop="name" label="资产类型" width="150"></el-table-column>
      <el-table-column prop="distributionBase" label="分配基数" width="90"></el-table-column>
      <el-table-column label="状态" width="50">
        <template slot-scope="scope">
          <p>{{ scope.row.effectiveStatus === true ? '有效' : '无效' }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="trackTime" label="最后修改日期" min-width="200"></el-table-column>
      <el-table-column fixed="right" label="操作" width="140">
        <template>
          <el-button type="text" size="small">预览</el-button>
          <el-button type="text" size="small">修改</el-button>
          <el-button type="text" size="small" disabled>失效</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination class="acr-pagination" @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   background layout="prev, pager, next" :page-size="11" :pager-count="5"
                   :total="propertyTypeTableData.length">
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "PropertyTypeTable",
  props: {
    propertyTypeTableData: Array,
  },
  data() {
    return {
      showTableData: []
    }
  },
  beforeMount() {
    this.processTableData();
  },
  watch: {
    propertyTypeTableData: function () {
      this.processTableData();
    }
  },
  methods: {
    processTableData() {
      if (this.propertyTypeTableData.length > 11) {
        this.showTableData = this.propertyTypeTableData.slice(0, 11)
      } else {
        this.showTableData = this.propertyTypeTableData
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      if (val === 1) {
        this.showTableData = this.propertyTypeTableData.slice(0, 11)
      } else {
        this.showTableData = this.propertyTypeTableData.slice((val - 1) * 11, (((val - 1) * 11) + 11))
      }
    },
  }
}
</script>

<style scoped>

</style>